module.exports = __webpack_public_path__ + "static/media/kaduha_mugano_mushubi_road5.7361e49d.jpg";